import { twJoin } from "tailwind-merge"
import { Fragment } from "react"
import { getFaqData } from "./data"
import { Collapse } from "@screens/HomeV2/components/Collapse"
import { JsonLdFaq } from "./JsonLdFaq"
import Section from '@components/Section'
import Container from '@components/UI/Container'
import React from "react";

const faqData = getFaqData({ forSchema: false })

export const Faq = () => (
  <>
    <JsonLdFaq />
    <Section
      mods={{
        py: true,
        'no-margin': true
      }}
      className={''}
    >
      <Container>
      <div className={twJoin("mx-auto max-w-[892px] flex flex-col gap-y-32p 768:gap-y-48p")}>
        <div className={twJoin("text-center", "flex flex-col gap-y-24p")}>
          <h2 className={twJoin("text-26p", "1024:text-44p", "font-600 text-neutral2-900")}>FAQ</h2>
        </div>
        <div className={twJoin("flex flex-col gap-24p 1024:gap-32p")}>
          {faqData.map((faq, index) => (
            <Fragment key={`${faq.title}-${index}`}>
              <Collapse
                className={twJoin("[&_.collapse-button]:gap-8p", "[&_.collapse-content]:pt-12p", "flex flex-col")}
                title={({ isOpen }) => (
                  <span
                    className={twJoin(
                      "text-left",
                      "text-18p leading-26p font-500",
                      "1024:text-22p 1024:leading-28p",
                      isOpen ? "text-slate-blue-600" : "text-neutral2-900"
                    )}
                  >
                    {faq.title}
                  </span>
                )}
                iconFunc={({ isOpen }) => (
                  <div className={twJoin("relative", "flex items-center justify-center", "w-24p h-24p")}>
                    <div className={twJoin("absolute", "w-14p h-2p bg-neutral2-900")} />
                    <div
                      className={twJoin(
                        "absolute",
                        "w-14p h-2p  transition-all",
                        isOpen ? "rotate-0 bg-slate-blue-600" : "rotate-90 bg-neutral-900"
                      )}
                    />
                  </div>
                )}
              >
                <span
                  className={twJoin(
                    "text-16p leading-26p font-400 text-neutral2-700",
                    "1024:text-18p 1024:leading-28p"
                  )}
                >
                  {faq.description}
                </span>
              </Collapse>
              {faqData.length - 1 === index ? null : <div className={twJoin("w-full h-1p bg-neutral2-400")} />}
            </Fragment>
          ))}
        </div>
      </div>
      </Container>
    </Section>
  </>
)
